
import { Component } from '@angular/core';
import { SessionContextService } from '../../context/session-context.service';

@Component({
    selector: 'app-footer',
    templateUrl: 'footer.component.html'
})

export class FooterComponent {

    public year: Date = new Date();

    constructor(
        private _sessionContext: SessionContextService
    ) { }

    public get version(){
        return this._sessionContext.version;
    }

}
